import { watch, when, on } from '@arcgis/core/core/reactiveUtils';
import { useEffect, useState, useCallback } from 'react';

function useWatchEffect(getValue, callback, options) {
  useEffect(() => {
    const handle = watch(getValue, callback, { initial: true, ...options });
    return () => handle.remove();
  }, [callback, getValue, options]);
}
function useWhenEffect(getValue, callback, options) {
  useEffect(() => {
    const handle = when(getValue, callback, { initial: true, ...options });
    return () => handle.remove();
  }, [callback, getValue, options]);
}
function useWatchState(getValue, deps, options) {
  const [state, setState] = useState();
  const cb = useCallback(getValue, deps ?? []);
  useWatchEffect(cb, setState, options);
  return state;
}
function useOnEvent(target, event, callback, options) {
  useEffect(() => {
    const handle = on(
      typeof target === "function" ? target : () => target,
      event,
      callback,
      options
    );
    return () => handle.remove();
  }, [callback, event, options, target]);
}
function useArcState(acc, property) {
  const [state, setState] = useState(acc[property]);
  useWatchEffect(() => acc[property], setState);
  const setArcState = useCallback(
    (newValue) => {
      if (typeof newValue === "function") {
        newValue = newValue(
          acc[property]
        );
      }
      acc.set(property, newValue);
      setState(newValue);
    },
    [acc, property]
  );
  return [state, setArcState];
}

export { useArcState, useOnEvent, useWatchEffect, useWatchState, useWhenEffect };
